module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "base-item-wrapper"
  }, [_c('div', {
    staticClass: "base-item",
    attrs: {
      "itemId": _vm.item.id
    },
    on: {
      "click": function($event) {
        _vm.itemClick(_vm.item.id)
      }
    }
  }, [_c('div', {
    staticClass: "img-container"
  }, [_c('ts-image', {
    attrs: {
      "src": _vm.picUrl,
      "width": "200",
      "height": "200",
      "canView": false,
      "disabledHover": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item-desc"
  }, [_c('h2', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "desc-title"
  }, [_c('span', [_vm._v(_vm._s(_vm.productNo) + _vm._s(_vm.typeComputed) + " ")]), _vm._v(_vm._s(_vm.num) + _vm._s(_vm.unit))]), _vm._v(" "), _c('h2', {
    staticClass: "desc-title"
  }, [_vm._v(_vm._s(_vm.desc))]), _vm._v(" "), (_vm.time) ? _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.time))]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "onepx-t footer"
  }, [_c('ts-image', {
    attrs: {
      "shape": "round",
      "src": _vm.userHeadIcon,
      "width": "30",
      "height": "30",
      "canView": false,
      "disabledHover": ""
    }
  }), _vm._v("  " + _vm._s(_vm.userName) + "\r\n    ")], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-95ed5bd0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/baseItem/baseItem.vue
// module id = 851
// module chunks = 39